import { State, Action, FormData, BillingAddress } from "./types";

export const initialFormData: FormData = {
  firstName: "",
  lastName: "",
  email: "",
  accountType: "",
  termsAccepted: false,
  billingAddress: {
    address1: "",
    address2: "",
    city: "",
    postcode: "",
    country: "",
    companyName: "",
  },
};

export const initialState: State = {
  step: 1,
  formData: initialFormData,
  errors: {},
  isSubmitting: false,
};

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "SET_STEP":
      return { ...state, step: action.payload, errors: {} };

    case "UPDATE_FORM_DATA":
      return {
        ...state,
        formData: { ...state.formData, ...action.payload },
      };

    case "UPDATE_BILLING_ADDRESS":
      return {
        ...state,
        formData: {
          ...state.formData,
          billingAddress: {
            ...state.formData.billingAddress,
            ...action.payload,
          } as BillingAddress,
        },
      };

    case "SET_ERRORS":
      return { ...state, errors: action.payload };

    case "CLEAR_ERRORS":
      return { ...state, errors: {} };

    case "SET_IS_SUBMITTING":
      return { ...state, isSubmitting: action.payload };

    case "RESET":
      return initialState;

    default:
      return state;
  }
};
